module.exports = function() {
  return new Worker("/built/" + "f5277309dfd37d793f32.worker.js");
};